// extracted by mini-css-extract-plugin
export default {"container":"CashDescription_container__K0X9W","total-cash-title":"CashDescription_total-cash-title__77FKK","hide":"CashDescription_hide__I+PhS"};